<template>
  <div class="transactionList">
    <div class="transactionList__list__item">
        <div class="transactionList__list__item__left">
          <div class="transactionList__list__item__left__info">
            <p class="small-font title">Campaign Name</p>
            <h3 class="subhead name">{{campaign.title}}</h3>
            <p class="small-font invoice">Invoice ID {{campaign.invoice_number}}</p>
          </div>
          <div class="transactionList__list__item__left__detail">
            <h6 class="small-font">Campaign detail :</h6>
            <div class="transactionList__list__item__left__detail__table">
              <div class="content">
                <p class="small-font">
                  Period
                </p>
                <h6 class="small-font">{{formatDate(campaign.start)}} - {{formatDate(campaign.end)}}</h6>
              </div>
              <div class="content">
                <p class="small-font">
                  Ads Duration
                </p>
                <h6 class="small-font">{{campaign.duration}} Seconds</h6>
              </div>
              <div class="content">
                <p class="small-font">
                  Total Listing
                </p>
                <h6 class="small-font">{{campaign.total_item}} Items</h6>
              </div>
            </div>
            <!-- <div class="action">
              <i class="icon-chevrondown" v-if="isMobile" @click.stop="toggle"></i>
            </div> -->
          </div>
          <!-- <div class="transactionList__list__item__left__detail" v-if="isOpen">
            <div class="transactionList__list__item__left__detail__table">
              <div class="content">
                <p class="small-font">
                  Approved
                </p>
                <h6 class="small-font">90 Items</h6>
              </div>
              <div class="content">
                <p class="small-font">
                  Rejected
                </p>
                <h6 class="small-font">10 Items</h6>
              </div>
              <div class="content">
                <h3 class="small-font color-skyblue">
                  Refund applied
                  <i></i>
                </h3>
              </div>
            </div>
          </div> -->
        </div>
        <div class="transactionList__list__item__middle">
          <div class="transactionList__list__item__middle__status">
            <p class="small-font title">
              Campaign Status :
            </p>
            <div class="content">
              <ul>
                <template v-if="campaign.get_status == 'Waiting for Payment'">
                  <li class="small-font">Waiting for Approval</li>
                  <li class="small-font">Upcoming</li>
                  <li class="small-font">Active</li>
                  <li class="small-font">Campaign End</li>
                </template>
                <template v-if="campaign.get_status == 'Waiting for Approval'">
                  <li class="small-font active">Waiting for Approval</li>
                  <li class="small-font">Upcoming</li>
                  <li class="small-font">Active</li>
                  <li class="small-font">Campaign End</li>
                </template>
                <template v-if="campaign.get_status == 'upcoming'">
                  <li class="small-font active">Waiting for Approval</li>
                  <li class="small-font active">Upcoming</li>
                  <li class="small-font">Active</li>
                  <li class="small-font">Campaign End</li>
                </template>
                <template v-if="campaign.get_status == 'active'">
                  <li class="small-font active">Waiting for Approval</li>
                  <li class="small-font active">Upcoming</li>
                  <li class="small-font active">Active</li>
                  <li class="small-font ">Campaign End</li>
                </template>
                <template v-if="campaign.get_status == 'expired' && orderStatus == 'paid'">
                  <li class="small-font active">Waiting for Approval</li>
                  <li class="small-font active">Upcoming</li>
                  <li class="small-font active">Active</li>
                  <li class="small-font active">Campaign End</li>
                </template>
                <template v-if="campaign.get_status == 'disapproved'">
                  <h3 class="small-font color-grey">Disapproved</h3>
                </template>
                <template v-if="campaign.get_status == 'Canceled'">
                  <h3 class="small-font color-grey">Canceled</h3>
                </template>
                <template v-if="campaign.get_status == 'expired' && orderStatus != 'paid'">
                  <h3 class="small-font color-grey">Expired</h3>
                </template>
              </ul>
            </div>
          </div>
        </div>
        <div class="transactionList__list__item__right">
          <div class="transactionList__list__item__right__price">
            <p class="small-font title">Total price</p>
            <h3 class="subhead price">{{campaign.net_price | formatMoney}}</h3>
            <router-link :to="{name:'invoicereceipt', params: { invoice_id: campaign.invoice_id }}" class="small-font color-pink invoice" target= '_blank'>
              View Invoice
            </router-link>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { formatShortDate } from '@/lib/util'

export default {
  name: 'adx-transaction-list',
  components: {
  },
  props: {
    campaign: {
      required: false
    },
    orderStatus: {
      required: false
    },
  },
  data() {
    return {
      isOpen: window.innerWidth < 769 ? true : false
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth < 769 ? false : true
    }
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    gotoInvoice(itemID) {
      this.$router.push({name:'invoicereceipt', params: { invoice_id: itemID }})
    },
    formatDate(date) {
      return formatShortDate(date)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>